import type { ThemeState } from '@atlaskit/tokens';
import { setGlobalTheme } from '@atlaskit/tokens';

import { fg } from '@confluence/feature-gating';

export const applyTheme = async (theme: Partial<ThemeState>): Promise<void> => {
	if (!fg('confluence_theming_utils_typography_modernized') && theme.typography) {
		delete theme.typography;
	}

	await setGlobalTheme(theme);
};
